import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Box,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ListAltIcon from '@material-ui/icons/ListAlt';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import CategoryIcon from '@material-ui/icons/Category';
import PeopleIcon from '@material-ui/icons/People';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import LinkIcon from '@material-ui/icons/Link';
import SendIcon from '@material-ui/icons/Send';
import HomeIcon from '@material-ui/icons/Home';
import AssessmentIcon from '@material-ui/icons/Assessment';

const useStyles = makeStyles((theme) => ({
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    backgroundColor: '#16213e',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
    },
  },
  logoText: {
    fontFamily: 'TESLA, sans-serif',
    fontSize: 22,
    fontWeight: 'bold',
    color: '#f47d06',
    textShadow: '2px 2px #333',
    [theme.breakpoints.up('sm')]: {
      fontSize: 28,
    },
  },
  listItem: {
    padding: theme.spacing(1.5, 2),
    margin: theme.spacing(0.5, 1),
    borderRadius: 8,
    '&:hover': {
      backgroundColor: 'rgba(244, 125, 6, 0.2)',
    },
  },
  listItemSelected: {
    backgroundColor: 'rgba(244, 125, 6, 0.3) !important',
    borderLeft: '4px solid #f47d06',
  },
  listItemIcon: {
    color: '#a0a0a0',
    minWidth: 40,
  },
  listItemIconSelected: {
    color: '#f47d06',
  },
  listItemText: {
    '& .MuiTypography-root': {
      fontSize: 14,
      fontWeight: 500,
    },
  },
  divider: {
    backgroundColor: 'rgba(255,255,255,0.1)',
    margin: theme.spacing(2, 0),
  },
  sectionTitle: {
    color: '#888',
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 1,
    padding: theme.spacing(2, 2, 1, 2),
  },
}));

const menuItems = [
  { path: '/', label: 'Welcome', icon: HomeIcon },
  { path: '/dashboard', label: 'Dashboard', icon: DashboardIcon },
  { path: '/orders', label: 'Orders', icon: ListAltIcon },
  { path: '/place-order', label: 'Place Order', icon: SendIcon },
  { path: '/credentials', label: 'Credentials', icon: VpnKeyIcon },
  { path: '/alerts', label: 'Alerts', icon: NotificationsActiveIcon },
];

const managementItems = [
  { path: '/catalogs', label: 'Catalogs & Strategies', icon: CategoryIcon },
  { path: '/users', label: 'Users', icon: PeopleIcon },
  { path: '/subscriptions', label: 'Subscriptions', icon: LinkIcon },
];

const analyticsItems = [
  { path: '/market-intelligence', label: 'Market Intelligence', icon: AssessmentIcon },
  { path: '/performance', label: 'Performance', icon: TrendingUpIcon },
];

function SidebarContent({ onItemClick }) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const handleNavigation = (path) => {
    history.push(path);
    // Close mobile drawer after navigation
    if (onItemClick) {
      onItemClick();
    }
  };

  const renderMenuItems = (items) => (
    items.map((item) => {
      const Icon = item.icon;
      const isSelected = location.pathname === item.path;
      return (
        <ListItem
          button
          key={item.path}
          onClick={() => handleNavigation(item.path)}
          className={`${classes.listItem} ${isSelected ? classes.listItemSelected : ''}`}
        >
          <ListItemIcon className={`${classes.listItemIcon} ${isSelected ? classes.listItemIconSelected : ''}`}>
            <Icon />
          </ListItemIcon>
          <ListItemText primary={item.label} className={classes.listItemText} />
        </ListItem>
      );
    })
  );

  return (
    <>
      <Box className={classes.logo}>
        <Typography className={classes.logoText}>MGM Trader</Typography>
      </Box>

      <Typography className={classes.sectionTitle}>Main</Typography>
      <List>
        {renderMenuItems(menuItems)}
      </List>

      <Divider className={classes.divider} />

      <Typography className={classes.sectionTitle}>Management</Typography>
      <List>
        {renderMenuItems(managementItems)}
      </List>

      <Divider className={classes.divider} />

      <Typography className={classes.sectionTitle}>Analytics</Typography>
      <List>
        {renderMenuItems(analyticsItems)}
      </List>
    </>
  );
}

export default SidebarContent;
